/**
 * Sets the document body and html element overflow to hidden to prevent scrolling.
 */
export function disableDocumentScrolling() {
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
}

/**
 * Sets the document body and html element overflow back to its initial value to allow scrolling.
 */
export function enableDocumentScrolling() {
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
}

/**
 * Scrolls to the top of the page.
 */
export function scrollToTopOfPage() {
  window.scrollTo(0, 0);
}

/**
 * Scrolls to view the element.
 */
export function scrollElementIntoView(elementName) {
  const element = document.querySelector(`#locatorv2embed .${elementName}`);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
  }
}

export function isMobile(){
  return (window.screen.width < 768 || window.innerWidth < 768 || document.getElementById('locatorv2embed').clientWidth < 768);
}

/**
 * Set body style to default color
 */
export function setDefaultBackgroundColor() {
  document.body.style.backgroundColor = 'unset';
}
